import { createAction } from '@reduxjs/toolkit';

import { SCENES_ACTIONS } from 'js/src/data/scenes/scenes-types';

export interface ShowFullscreenSelectorPayload {
    targetSlideIndex: number | null;
    targetSlideId?: string;
    targetSlideGroupId?: string;
    sceneGroupCategory?: string;
}
export const showFullscreenSelector = createAction<ShowFullscreenSelectorPayload>(
    SCENES_ACTIONS.SHOW_FULLSCREEN_SELECTOR,
);
export const hideFullscreenSelector = createAction<undefined>(
    SCENES_ACTIONS.HIDE_FULLSCREEN_SELECTOR,
);

export const showFullscreenSwapSceneSelector = createAction<undefined>(
    SCENES_ACTIONS.SHOW_FULLSCREEN_SWAP_SCENE_SELECTOR,
);
export const hideFullscreenSwapSceneSelector = createAction<undefined>(
    SCENES_ACTIONS.HIDE_FULLSCREEN_SWAP_SCENE_SELECTOR,
);

export const showOverlaySelector = createAction<{
    startTime: number;
    endTime: number;
}>(SCENES_ACTIONS.SHOW_OVERLAY_SELECTOR);
export const hideOverlaySelector = createAction<undefined>(SCENES_ACTIONS.HIDE_OVERLAY_SELECTOR);

/**
 * Records a slide which has a slide design applied to it differing from the default
 */
export const trackChangedSceneDesign = createAction<{ sceneId: string }>(
    SCENES_ACTIONS.TRACK_CHANGED_SCENE_DESIGN,
);

/**
 * Clears any tracked value for a slide that has either the original recommendation
 * or default scene design re-applied back to it
 */
export const clearTrackedSlide = createAction<{ sceneId: string }>(
    SCENES_ACTIONS.CLEAR_TRACKED_SLIDE,
);

/**
 * Records a text asset which has been changed
 */
export const trackChangedTextAsset = createAction<{
    sceneId: string;
    assetId: string;
}>(SCENES_ACTIONS.TRACK_SLIDE_TEXT_ASSET);

/**
 * Records a new slide which text assets which be highlighted on first edit
 */
export const trackChangedTextAssetSlide = createAction<{ sceneId: string }>(
    SCENES_ACTIONS.TRACK_SLIDE,
);

/**
 * Remove previously added slide which text assets would be highlighted on first edit
 */
export const clearTextAssetTrackedSlide = createAction<{ sceneId: string }>(
    SCENES_ACTIONS.CLEAR_TEXT_ASSET_TRACKED_SLIDE,
);

/**
 * Removes previously recorded slide text asset ids
 */
export const clearTrackedSlideTextAssets = createAction<{ sceneId: string }>(
    SCENES_ACTIONS.CLEAR_TRACKED_SLIDE_TEXT_ASSETS,
);

/**
 * Hides any scene sections
 */
export const hideAllSceneSections = createAction<undefined>(SCENES_ACTIONS.HIDE_SCENE_SECTIONS);

/**
 * Shows the scene selector to replace the given slide with other scene designs,
 * if the slide has not been previously invalidated
 */
export const setSceneSelectorForSlide = createAction<{ sceneId: string }>(
    SCENES_ACTIONS.SET_SCENE_SELECTOR_SLIDE_ID,
);

export const setSwapSceneDesignForSlide = createAction<{
    sceneId: string | null;
}>(SCENES_ACTIONS.SET_SWAP_SCENE_DESIGN_SLIDE_ID);

export const setOverlayForSceneGroup = createAction<{ sceneGroupId: string }>(
    SCENES_ACTIONS.SET_OVERLAY_SELECTOR_SCENE_GROUP_ID,
);

export const setFocusedAssetInfo = createAction<{
    sceneGroupId: string;
    sceneId: string;
    subsceneIndex: number;
    assetId: string;
    assetType: string;
    rootAssetGroupId?: string | null;
}>(SCENES_ACTIONS.SET_FOCUSED_ASSET);

export const clearFocusedAsset = createAction<undefined>(
    SCENES_ACTIONS.CLEAR_CURRENTLY_EDITING_ASSET,
);

export const setFocusedSceneInfo = createAction<{
    sceneGroupId: string | null;
    sceneId: string | null;
    subsceneIndex?: number;
}>(SCENES_ACTIONS.SET_CURRENTLY_EDITING_SCENE);

export const setMorphSwapMode = createAction<boolean>(SCENES_ACTIONS.SET_MORPH_SWAP_MODE);

export const startPasteUpload = createAction<{
    assetId: string;
    sceneId: string;
    uploadSessionId: string;
    thumbnailDataUrl?: string;
}>('scenes/startPasteUpload');

export const endPasteUpload = createAction<{
    assetId: string;
}>('scenes/endPasteUpload');
